import { lazy } from 'react';

// ** Document title
const TemplateTitle = 'VALJOB';

// ** Default Route
const DefaultRoute = '/tableau-de-bord';

// ** Merge Routes
const Routes = [
    {
        path: '/tableau-de-bord',
        component: lazy(() => import('@views/dashbord/candidate/Dashboard')),
    },
    {
        path: '/partners/export/:s/:typeFile',
        component: lazy(() => import('@views/export')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true,
        },
    },
    {
        path: '/login',
        component: lazy(() => import('@views/authentification/login')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true,
        },
    },
    {
        path: '/forgot-password',
        component: lazy(() => import('@views/authentification/ForgotPassword')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true,
        },
    },
    {
        path: '/set-password/:token',
        component: lazy(() => import('@views/authentification/ResetPassword')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true,
        },
    },
    {
        path: '/ma-recherche',
        component: lazy(() => import('@views/my-search')),
    },
    {
        path: '/mes-favoris',
        component: lazy(() => import('@views/favoris')),
    },
    {
        path: '/mes-informations',
        component: lazy(() => import('@views/profile/information')),
    },
    {
        path: '/mes-documents',
        component: lazy(() => import('@views/myDocs')),
    },
    {
        path: '/agency-docs',
        component: lazy(() => import('@views/agencyDocs/AgencyDocs')),
    },
    {
        path: '/notifications',
        component: lazy(() => import('@views/notifications/Notifications')),
    },
    {
        path: '/fiches-horaires',
        component: lazy(() => import('@views/timeSheet/TimeSheet')),
    },
    {
        path: '/register/user',
        component: lazy(() => import('@views/authentification/register/Register')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true,
        },
    },
    {
        path: '/profil',
        component: lazy(() => import('@views/profile/my-profil')),
    },
    {
        path: '/profil/my-documents',
        component: lazy(() => import('@views/profile/my-profil/MyAccountDocuments/MyAccountDocuments')),
    },
    {
        path: '/mobility',
        component: lazy(() => import('@views/profile/Mobility/Mobility')),
    },
    {
        path: '/rechercher-un-emploi',
        component: lazy(() => import('@views/search-jobs')),
    },
    {
        path: '/candidatures-en-attente',
        component: lazy(() => import('@views/candidatures/candidate/pending')),
    },
    {
        path: '/candidatures-retenues',
        component: lazy(() => import('@views/candidatures/candidate/retenue')),
    },
    {
        path: '/candidatures-refusees',
        component: lazy(() => import('@views/candidatures/candidate/refused')),
    },
    {
        path: '/mes-propositions',
        component: lazy(() => import('@views/candidatures/candidate/proposals')),
    },
    {
        path: '/missions-valides',
        component: lazy(() => import('@views/candidatures/candidate/validMissions/ValidMissions')),
    },
    {
        path: '/support',
        className: 'email-application',
        component: lazy(() => import('@views/parameters/support')),
    },
    {
        path: '/parametres',
        component: lazy(() => import('@views/parameters/security')),
    },
    {
        path: '/communication',
        component: lazy(() => import('@views/parameters/communicate')),
    },
    {
        path: '/apply/annonce/:id/:source',
        component: lazy(() => import('@views/share')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true,
        },
    },
    {
        path: '/job/:slug/:source/apply',
        component: lazy(() => import('@views/share2')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true,
        },
    },
    {
        path: '/annonce/:id/:source',
        component: lazy(() => import('@views/share')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true,
        },
    },
];

export { DefaultRoute, TemplateTitle, Routes };
